'use strict';
import SweetAlerts from '../../helpers/sweetAlerts.js';

const main = () => {
  const form = document.querySelector('form');

  if (!form) {
    console.error("No se encontró el formulario en el DOM.");
    return { init: () => { } };
  }

  const showLoginError = () => {
    // Django re-renderiza el login con el error cuando las credenciales fallan
    const errorEl = document.querySelector('#login-error');
    if (errorEl) {
      const message = errorEl.dataset.message || "Las credenciales ingresadas no son correctas.";
      SweetAlerts.error("Credenciales incorrectas", message);
    }
  };

  const handleSubmitFormLogin = () => {
    // Dejar que el formulario se envíe normalmente
    // Django manejará la redirección correctamente según el grupo del usuario
    // No interceptamos el submit con JavaScript para permitir que el servidor maneje todo
  };

  const passwordToggleInit = () => {
    const passwords = document.querySelectorAll('.data-password');
    if (passwords) {
      passwords.forEach(password => {
        const passwordInput = password.querySelector('[data-password-input]');
        const passwordToggler = password.querySelector('[data-password-toggle]');
        passwordToggler.addEventListener('click', () => {
          if (passwordInput.type === 'password') {
            passwordInput.setAttribute('type', 'text');
            passwordToggler.classList.add('show-password');
          } else {
            passwordInput.setAttribute('type', 'password');
            passwordToggler.classList.remove('show-password');
          }
        });
      });
    }
  };

  return {
    init: () => {
      handleSubmitFormLogin();
      passwordToggleInit();
      showLoginError();
    }
  };
};

document.addEventListener('DOMContentLoaded', () => {
  main().init();
});
